import { render, staticRenderFns } from "./CanvasCarousel.vue?vue&type=template&id=415c1098"
import script from "./CanvasCarousel.vue?vue&type=script&lang=js"
export * from "./CanvasCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports